import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.75 9.696a2.76 2.76 0 0 0-1.454-2.45l-6.472-3.531a3.8 3.8 0 0 0-3.648 0l-6.472 3.53A2.76 2.76 0 0 0 2.25 9.697c0 1.037.544 1.953 1.454 2.45l1.546.843v3.71c0 .956.49 1.834 1.311 2.351 1.805 1.135 3.622 1.703 5.439 1.703s3.635-.567 5.439-1.703a2.77 2.77 0 0 0 1.311-2.351v-3.71l1.5-.818V16a.75.75 0 0 0 1.5 0v-6c0-.042-.018-.08-.024-.12.004-.063.024-.12.024-.184m-4.5 7.003c0 .43-.233.845-.609 1.081-3.122 1.963-6.157 1.964-9.28 0a1.3 1.3 0 0 1-.61-1.081v-2.892l3.426 1.869a3.8 3.8 0 0 0 3.648 0l3.426-1.869v2.892zm2.327-5.87-6.472 3.532a2.3 2.3 0 0 1-2.211 0L4.422 10.83a1.27 1.27 0 0 1-.673-1.133c0-.48.251-.903.673-1.133l6.472-3.531a2.3 2.3 0 0 1 1.105-.283c.379 0 .76.095 1.105.283l6.472 3.53c.422.23.673.654.673 1.134s-.25.903-.672 1.133"
    }, null, -1)
  ])))
}
export default { render: render }